import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/home.svg'
import _imports_1 from '@/assets/icons/zoomIn.svg'
import _imports_2 from '@/assets/icons/zoomOut.svg'
import _imports_3 from '@/assets/icons/rotate.svg'
import _imports_4 from '@/assets/icons/locate.svg'


const _withScopeId = n => (_pushScopeId("data-v-7eaf60a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigationControls" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "controlImg",
  alt: "Course de l'escalade",
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "controlImg",
  alt: "Course de l'escalade",
  src: _imports_1
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "controlImg",
  alt: "Course de l'escalade",
  src: _imports_2
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "controlImg",
  alt: "Course de l'escalade",
  src: _imports_3
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "controlImg",
  alt: "Me localiser",
  src: _imports_4
}
const _hoisted_11 = {
  key: 1,
  class: "spinner"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["navigationControl homeControl", {'isNotMobileView': !_ctx.isMobileView}]),
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.flyToHomePosition && _ctx.flyToHomePosition(...args))),
      title: "Vue par défaut"
    }, _hoisted_3, 2),
    (!_ctx.isMobileView)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["navigationControl zoomInControl", {'isNotMobileView': !_ctx.isMobileView}]),
          onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.zoomIn && _ctx.zoomIn(...args))),
          title: "Zoom avant"
        }, _hoisted_5, 2))
      : _createCommentVNode("", true),
    (!_ctx.isMobileView)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["navigationControl zoomOutControl", {'isNotMobileView': !_ctx.isMobileView}]),
          onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.zoomOut && _ctx.zoomOut(...args))),
          title: "Zoom arrière"
        }, _hoisted_7, 2))
      : _createCommentVNode("", true),
    (_ctx.mapMode === 3 && !_ctx.isMobileView)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["navigationControl rotateControl", { 'selected': _ctx.rotationEnabled, 'isNotMobileView': !_ctx.isMobileView}]),
          onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.toggleMouseLeftRotation && _ctx.toggleMouseLeftRotation(...args))),
          title: "Pivoter en 3D"
        }, _hoisted_9, 2))
      : _createCommentVNode("", true),
    (_ctx.geolocationEnabled)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(["navigationControl locateControl", {'selected': _ctx.geolocationOn, 'isNotMobileView': !_ctx.isMobileView}]),
          onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.locateMe && _ctx.locateMe(...args))),
          title: "Me localiser"
        }, [
          (!_ctx.locationLoading)
            ? (_openBlock(), _createElementBlock("img", _hoisted_10))
            : _createCommentVNode("", true),
          (_ctx.locationLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}